export default "__VITE_ASSET__DKf0iMX1__"